import { css } from '@emotion/css'
import { flash } from '../../styles/animations'

const styles = {
  animated: css({
    animation: `${flash} 2s infinite`,
  }),
}

export default styles
